import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';

const CRUMBS = [
  { label: 'Workspace', to: '/email-accounts' },
  { label: 'Email Accounts', to: '/email-accounts' },
  { label: 'Connect mailbox' },
];

/**
 * Pending state for `/email-accounts/connect`, mirroring the page's geometry.
 * Its measurements duplicate `ConnectAccountPage`'s on purpose — change both together.
 */
export function ConnectAccountPendingState() {
  return (
    <>
      <Topbar crumbs={CRUMBS} title="Connect a mailbox" />

      <div
        className="flex min-h-0 flex-1 flex-col overflow-hidden md:flex-row"
        style={{ background: 'var(--paper)' }}
        aria-busy="true"
        aria-live="polite"
      >
        <div
          className="hidden shrink-0 flex-col md:flex"
          style={{
            width: 280,
            padding: '18px 20px 18px 32px',
            borderRight: '1px solid var(--ink-200)',
            gap: 14,
          }}
        >
          <Skeleton style={{ height: 36, borderRadius: 9 }} className="w-full" />
          <div className="flex flex-col gap-1">
            {Array.from({ length: 6 }, (_, i) => (
              <Skeleton key={i} className="h-10 w-full rounded-xl" />
            ))}
          </div>
        </div>

        <div
          className="flex w-full flex-col gap-2 p-4 md:hidden"
          style={{ borderBottom: '1px solid var(--ink-200)' }}
        >
          <div className="flex flex-row items-center gap-2 overflow-x-auto pb-1">
            {Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} className="h-9 w-28 shrink-0 rounded-md" />
            ))}
          </div>
        </div>

        <div
          className="flex min-w-0 flex-1 flex-col"
          style={{ padding: '20px 32px 24px', gap: 20 }}
        >
          <div className="flex items-center" style={{ gap: 14 }}>
            <Skeleton style={{ width: 44, height: 44, borderRadius: 12 }} />
            <div className="flex flex-col gap-1.5">
              <Skeleton className="h-4 w-40 rounded-md" />
              <Skeleton className="h-3 w-64 rounded-md" />
            </div>
          </div>
          <Skeleton className="h-40 w-full rounded-xl" />
        </div>
      </div>
    </>
  );
}
